import { rawData } from "../rawData";
import config from "../config.json";

const { dataSettings } = config;
const { uid } = dataSettings;

const getDoisFromUids = (arrayOfIds) => {
  const filteredData = rawData.filter((d) => arrayOfIds.includes(d[uid]));

  return filteredData.map((d) => d["doi"]);
};

export { getDoisFromUids };
